import { Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useCallback, useState } from "react";

function FeedbackQuestionsAdmin(props) {
  const [updateStatus, setUpdateStatus] = useState("");
  const [changed, setChanged] = useState(false);
  const [workingQuestions, setWorkingQuestions] = useState(
    Object.entries(props.questions ?? [])
      .map(([id, details]) => ({ questionId: id, ...details }))
      .sort((a, b) => a.formOrder - b.formOrder),
  );

  const handleFieldChange = (questionOrder, field, value) => {
    setWorkingQuestions((prevQuestions) =>
      prevQuestions.map((question, index) => (index === questionOrder ? { ...question, [field]: value } : question)),
    );
    setChanged(true);
  };

  const handleDelete = (questionOrder) => {
    setWorkingQuestions((prevQuestions) => prevQuestions.filter((_, index) => index !== questionOrder));
    setChanged(true);
  };

  const updateQuestions = useCallback(() => {
    const questionsToSave = Object.fromEntries(
      workingQuestions.map(({ questionId, ...rest }, index) => [questionId, Object.assign({ formOrder: index }, rest)]),
    );

    fetch("/api/update-form-questions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        questions: questionsToSave,
        projectSlug: props.projectSlug,
      }),
    })
      .then((response) => {
        console.log(response);
        setUpdateStatus("Update success");
        setChanged(false);
      })
      .catch((error) => {
        console.error(error);
        setUpdateStatus("Error updating questions", error.message);
      });
  }, [workingQuestions, props.projectSlug]);

  const addQuestion = () => {
    setWorkingQuestions((prevQuestions) => [
      ...prevQuestions,
      { questionId: `question${prevQuestions.length + 1}`, text: "New question", type: "textarea", condition: {} },
    ]);
    setChanged(true);
  };

  const questions = workingQuestions.map((question, questionOrder) => (
    <tr key={questionOrder}>
      <td>
        <IconButton color="error" aria-label="delete" onClick={() => handleDelete(questionOrder)}>
          <DeleteIcon />
        </IconButton>
      </td>
      <td>
        <input
          type="text"
          value={question.questionId}
          onChange={(e) => handleFieldChange(questionOrder, "questionId", e.target.value)}
        />
      </td>
      <td>
        <textarea
          cols={100}
          value={question.text}
          onChange={(e) => handleFieldChange(questionOrder, "text", e.target.value)}
        />
      </td>
      <td>
        <textarea
          value={
            typeof question.condition === "object" ? JSON.stringify(question.condition) : (question.condition ?? "")
          }
          onChange={(e) => handleFieldChange(questionOrder, "condition", e.target.value)}
        />
      </td>
    </tr>
  ));

  return (
    <div id="project-admin-feedback" className="nav-scroll-margin">
      <form
        onSubmit={(evt) => {
          evt.preventDefault();
          setUpdateStatus("Updating questions...");
          updateQuestions();
        }}
      >
        <h2>Feedback form</h2>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Question ID (must be unique)</th>
              <th>Question text</th>
              <th>Condition</th>
            </tr>
          </thead>
          <tbody>{questions}</tbody>
        </table>
        <Button variant="contained" color="primary" onClick={addQuestion}>
          +
        </Button>
        <br />
        <Button type="submit" variant="contained" disabled={!changed}>
          Update questions
        </Button>
        <div>{updateStatus}</div>
      </form>
    </div>
  );
}

export { FeedbackQuestionsAdmin };
